import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-5 shadow-[0_14px_34px_-26px_rgba(16,28,44,0.5)]" data-id="element-311" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-312" data-mp="345qptty5i7fz">
        <img src={testimonial.img} alt={testimonial.name} width={56} height={56} loading="lazy" decoding="async" className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-electric/40 ring-offset-2" data-id="element-313" data-mp="3872g81oumwp8" />
        <div className="min-w-0" data-id="element-314" data-mp="hskswxfudu7s">
          <p className="text-sm font-bold text-navy" data-id="element-315" data-mp="htmcjqaxbp14">{testimonial.name}</p>
          <p className="mt-0.5 text-xs text-navy/55" data-id="element-316" data-mp="d1ul7djy1f9x">
            <span aria-hidden="true" data-id="element-317" data-mp="d01dduxlgp0c">{testimonial.flag} </span>
            {testimonial.location}
          </p>
          <span className="mt-1 flex gap-0.5 text-ember" aria-label="5 sur 5 étoiles" data-id="element-318" data-mp="80ou1k5xm02i">
            {Array.from({
            length: 5
          }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-319" data-mp="10qnmlpjc4fbx" data-mpi={k} />)}
          </span>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-navy/10 pt-4 text-[15px] leading-relaxed text-navy/80" data-id="element-320" data-mp="vqrilqan0nwd">
        « {testimonial.quote} »
      </blockquote>
    </motion.figure>;
}